import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from 'src/environments/environment';
import { getBalance } from './pages/interfaces/getBalance';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CommonService {

  baseUrl = '';
  constructor(private http: HttpClient) { }
}


@Injectable()
export class dashboardService {

  environmentName = '';
  environmentUrl = '';

  constructor(private HttpClient: HttpClient) {

    this.environmentName = environment.environmentName;
    this.environmentUrl = environment.apiUrl;

  }

  getJSON(): Observable<any> {
    return this.HttpClient.get("./assets/data/profile.json", { responseType: 'json' });
  }

  getBalance(requestObject: getBalance): Observable<any> {
    return this.HttpClient.post(this.environmentUrl + "GetBalances", requestObject);
  }

  getIPAddress() {
    return this.HttpClient.get("http://api.ipify.org/?format=json");
  }
}


@Injectable()
export class headerLogoService {

  private logoSource = new BehaviorSubject('default');
  currentLogo = this.logoSource.asObservable();

  constructor() { }

  changeLogo(logoType: string) {
    this.logoSource.next(logoType)
  }

}

@Injectable()
export class headerBackgroundService {
  private bgSource = new BehaviorSubject('default');
  currentBg = this.bgSource.asObservable();

  constructor() { }

  changeBackground(bgcolorType: string) {
    this.bgSource.next(bgcolorType)
  }
}